export enum AccessServiceActions {
  ALL = '*',
  Scopes = 'scopes',
  Roles = 'roles',
  Invites = 'invites',
  Users = 'users',
  SignIn = 'signin',
  Switch = 'switch',
  Refresh = 'refresh',
  Password = 'password',
  Profile = 'profile',
  Otp = 'otp',
}
